export default __webpack_public_path__ + "static/media/zoom_in.4a0b82cd.svg";